import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import moment from 'moment'

Vue.use(Router)

const authGuard = (to, from, next) => {
  if (store.getters.token && store.getters.expires && ! moment.utc().isAfter(store.getters.expires)) {
    next()
  } else {
    store.dispatch('deauthenticate')
    next({
      path: '/login',
      // query: {
      //   r: window.btoa(`${ window.location.pathname }${ window.location.search }`)
      // }
    })
  }
}

const routes = [
  // {
  //   path: '*',
  //   name: 'not-found',
  //   component: () => import( /* webpackChunkName: "not-found" */ '../views/NotFound.vue')
  // },
  {
    path: '/',
    name: 'home',
    component: () => import( /* webpackChunkName: "home" */ '../views/Home.vue'),
    beforeEnter: authGuard,
    meta: {
      breadcrumbs: [
        { name: 'Home', path: '/' }
      ]
    }
  },
  {
    path: '/account',
    name: 'account',
    component: () => import( /* webpackChunkName: "account" */ '../views/Account.vue'),
    beforeEnter: authGuard,
    meta: {
      breadcrumbs: [
        { name: 'Home', path: '/' },
        { name: 'Account', path: '/account' }
      ]
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import( /* webpackChunkName: "login" */ '../views/Login.vue'),
    meta: {
      breadcrumbs: []
    }
  },
  {
    path: '/reset/:token?',
    name: 'reset',
    component: () => import( /* webpackChunkName: "reset" */ '../views/ResetPassword.vue'),
    meta: {
      breadcrumbs: []
    }
  },
  {
    path: '/product-request/:id?',
    name: 'product request',
    component: () => import( /* webpackChunkName: "product-request" */ '../views/Order.vue'),
    beforeEnter: authGuard,
    meta: {
      breadcrumbs: [
        { name: 'Home', path: '/' }
      ]
    }
  },
  {
    path: '/product-requests',
    name: 'product requests',
    component: () => import( /* webpackChunkName: "product-requests" */ '../views/Orders.vue'),
    beforeEnter: authGuard,
    meta: {
      breadcrumbs: [
        { name: 'Home', path: '/' },
        { name: 'Product Requests', path: '/product-requests' }
      ]
    }
  },
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const waitForStorageToBeReady = async (to, from, next) => {
  // console.log('waitForStorageToBeReady', 'waiting')
  await store.restored
  // console.log('waitForStorageToBeReady', 'restored')
  next()
}

router.beforeEach(waitForStorageToBeReady)

export default router